import React from 'react';
import axios from "../../containers/api";
import {Alert, Button, FormGroup, Input, Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../helpers/Utils";
 
 

class NewComment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModal: this.props && this.props.isModal,
             
            Title: "",
            Desc: "", 
            errors: []
        }
       /* console.log('test');*/
    }

    componentDidMount() {
        
    }

     
    componentWillMount() {
       
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data) {
                    this.loadProvinces();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
     
    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.Title.length ===0) {
            error.push("وارد كردن عنوان الزامی میباشد");
        }
        if (this.state.Desc.length ===0 ) {
            error.push("وارد كردن  پيام الزامی میباشد");
        }
        
        this.setState({errors: error});
        if (error.length === 0) {
            this.AddComment();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    AddComment= () => {
        const addModel = {
            Title: toEnglishNumbers(this.state.Title),
            Desc: toEnglishNumbers(this.state.Desc),
            Type:0
        };

        this.props.showSpinner();
        axios.post('api/v1/Comment/AddComment', addModel)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.props.showAlert(res.data.data.message, "success");  
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

 
    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>عنوان</Label>
                        <Input value={this.state.Title} 
                               onChange={(e) => this.setState({ Title: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>پیام</Label>
                        <Input value={this.state.Desc} type="textarea"
                               onChange={(e) => this.setState({ Desc: e.target.value })}/>
                    </FormGroup> 
                </div>

                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.props.showSweetAlert("آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "", "warning", this.validateInputData)}>
                            ثبت
                        </Button>
                    </FormGroup>
                </div>

                 
            </div>
        );
    }
}

export default NewComment;